import "./i18n";
import "./all-blocks.js";
import "./theme.scss";
import "./rank-math-seo-faq/script-faq.js";
import "./shared/preserve-c2b.js";

// Prevent the benign "ResizeObserver loop completed with undelivered notifications" error.
// Gutenberg's block previews trigger this error heavily. By wrapping all ResizeObserver
// callbacks in requestAnimationFrame, we break the synchronous loop that generates it —
// notifications are still delivered, just deferred to the next animation frame.
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

// Belt-and-suspenders: also suppress the error event in case it still fires
// (e.g. from ResizeObservers instantiated before our patch above).
window.addEventListener(
  "error",
  (e) => {
    if (e.message?.includes("ResizeObserver loop")) {
      e.stopImmediatePropagation();
    }
  },
  true,
);
